import cc_form__rules from "../../../validation/scenarios/cc_form__rules";


export default {
    model: {
        payment: cc_form__rules
    }
};
